import AssociatesResult from './ResultPage';

export default AssociatesResult;
